import React, { useState, useEffect } from "react";
import TextField from "@mui/material/TextField";

const DICOption = (props) => {
  return (
    <TextField
      size="small"
      variant="standard"
      sx={{ color: "#EFEFEF", width: "100%" }}
      onInput={(event) => {
        props.changeText(event.target.value);
      }}
      value={props.value}
      disabled={!props.editable}
      multiline={true}
      rows={3}
      inputProps={{
        spellCheck: false,
        autoCorrect: "off",
        autoCapitalize: "off",
        sx: {
          fontSize: "0.9rem",
          color: "#DB8829",
          fontWeight: "500",
          "@media (min-width: 1636px)": {
            fontSize: "1.4rem",
          },
        },
      }}
    />
  );
};

export default DICOption;
